import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import { AiFillStar } from "react-icons/ai";
import { MdOutlineAddShoppingCart, MdOutlineRemoveShoppingCart } from "react-icons/md";
import { AiOutlineArrowLeft } from "react-icons/ai";

const ProductDisplay = (props) => {
    const location = useLocation();
    const initialData = location.state[0];
    const [cart, setCart] = useState(location.state[1]);

    const [product, setProduct] = useState(null);
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        // const items = { cart: props.cart };
        navigate(`/${path}`, { state: cart });
      }


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`https://dummyjson.com/products`);
                const data = await response.json();
                const filteredProduct = data.products.find((product) => product.id === initialData);
                setProduct(filteredProduct);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [initialData]);

    if (!product) {
        return <div className='flex justify-center items-center h-96'><div class="relative flex w-64 animate-pulse gap-2 p-4">
            <div class="h-12 w-12 rounded-full bg-slate-400"></div>
            <div class="flex-1">
                <div class="mb-1 h-5 w-3/5 rounded-lg bg-slate-400 text-lg"></div>
                <div class="h-5 w-[90%] rounded-lg bg-slate-400 text-sm"></div>
            </div>
            <div class="absolute bottom-5 right-0 h-4 w-4 rounded-full bg-slate-400"></div>
        </div></div>;
    }

    const cartHandle = (id) => {
        const newCart = [...cart];
        const index = newCart.indexOf(id);
        if (index > -1) {
            newCart.splice(index, 1);
        } else {
            newCart.push(id);
        }
        setCart(newCart);
    };

    return (
        <>
            <Header cart={cart} />
            <div className='my-3 ms-2 products italic '>
                <button onClick={() => handleNavigation('homepage')} className='flex justify-center items-center align-middle gap-1 text-xs italic uppercase'><AiOutlineArrowLeft />Back to Home</button>
            </div>

            <div className='products gap-4 sm:mx-3 flex flex-row flex-wrap justify-center sm:justify-start items-center my-6'>
                <div>
                    <div className='italic font-bold uppercase text-3xl sm:text-xl animate-fade-right animate-delay-0'>{product.title}</div>
                    <div className='italic text-sm mt-1  animate-fade-right animate-delay-200'>{product.description}</div>
                    <div className='italic mt-1 text-xs  animate-fade-right animate-delay-300'>{product.category}</div>
                    <div className='w-full mt-3 rounded  animate-fade-right animate-delay-500'>
                        <img src={product.thumbnail} alt={`${product.title} Pic`} className='rounded shadow' />
                    </div>
                    <div className="image-list flex ">
                        {product.images.map((link, index) => (
                            <img key={index} src={link} alt={`pic ${index}`} className="m-2 w-24 sm:w-12 h-24 sm:h-12 object-cover rounded shadow" />
                        ))}
                    </div>
                </div>
                <div >

                    <div className='italic font-bold uppercase mt-1 text-3xl sm:text-xl flex flex-row items-start align-text-bottom gap-2  animate-fade-right animate-delay-300'>
                        <span>
                            $ <span className='text-5xl sm:text-4xl text-end'>{product.price}</span>
                        </span>
                        <span className='mt-6 uppercase italic text-sm sm:text-xs text-red-700 line-through'>${product.discountPercentage} OFF</span>
                    </div>

                    <div className="  animate-delay-500 mt-1 italic text-lg flex flex-row gap-1 align-middle items-center animate-fade-right ">
                        <AiFillStar className="text-yellow-500" />
                        {product.rating}
                    </div>

                    <div className=" animate-fade-right animate-delay-700 mt-1 flex flex-row text-center items-center justify-center text-xs border px-3 w-32 italic text-gray-900 border-gray-900">
                        ONLY {product.stock} LEFT
                    </div>
                    <div className='mt-2  animate-fade-right animate-delay-1000'>
                        {!cart.includes(product.id) ? (
                            <button
                                className="rounded text-md w-full text-gray-400 py-1 sm:py-2 text-center flex  flex-row flex-nowrap gap-2 items-center justify-center  bg-gradient-to-l from-gray-950 to-gray-800 animate-shake animate once shadow border-t border-t-gray-500 border-b-2 border-b-black "
                                onClick={() => cartHandle(product.id)}
                            >
                                <span className='italic uppercase text-xs'>+ Add to Cart</span>
                                <MdOutlineAddShoppingCart />
                            </button>
                        ) : (
                            <button
                                className=" rounded text-md w-full text-gray-950 py-1 sm:py-2 text-center flex flex-row flex-nowrap gap-2 items-center justify-center  bg-gradient-to-r from-gray-200 to-gray-400 animate-rotate-x animate once shadow border-t border-t-gray-100 border-b-2 border-b-gray-500 "
                                onClick={() => cartHandle(product.id)}
                            >
                                <span className='italic uppercase text-xs'>- Remove</span>
                                <MdOutlineRemoveShoppingCart />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>);
};

export default ProductDisplay;
